<template>
    <div v-if="isreadshow">     
         
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段编码" prop="bdcode" min-width="220" fixed></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <div >
                        <my-btn type="edit" @click="detail(scope.row.bdcode)">查看详情</my-btn>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/ckzjzy/get_list.json`"></my-pagination>
    </div>
</template>
                                                
<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
  
    data() {
        return{
            pgData:{
                zbprocode:'',
                sortname : 'bdcode',
                sortorder: 'asc',                   
            },
            form:{
            },
            isreadshow:true,
            tableData:[]
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //详情
        detail:function(bdcode){
            this.goto({
                path:'./detail',
                query:{
                    bdcode:bdcode,
                }
            });
        },
    },
    created() {
        if(this.getQuery('zbprocode')!==undefined){
            this.pgData.zbprocode=this.getQuery('zbprocode')
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
